import React, { useState } from 'react';
import { Autocomplete, TextField } from '@mui/material';

const LockFilter = ({ locks, locksLoading, lockFilter, setLockFilter }) => {
    const [searchInput, setSearchInput] = useState('');

    const getOptionLabel = (option) => {
        if (!option) return '';
        return option.lockNumber || '';
    };

    return (
        <Autocomplete
            size="small"
            options={locks || []}
            value={lockFilter}
            loading={locksLoading}
            inputValue={searchInput}
            onInputChange={(event, value) => setSearchInput(value)}
            className="sl-filter-autocomplete"
            getOptionLabel={getOptionLabel}
            onChange={(_, v) => setLockFilter(v)}
            componentsProps={{
                popper: {
                    style: { width: 380 },
                },
            }}
            filterOptions={(options, state) => {
                if (!state.inputValue) return options;

                const input = state.inputValue.toLowerCase();
                return options.filter((option) =>
                    option.lockNumber?.toLowerCase().includes(input) ||
                    option.serialNumber?.toLowerCase().includes(input) ||
                    option.number?.toLowerCase().includes(input) ||
                    option.status?.toLowerCase().includes(input)
                );
            }}
            renderOption={(props, option) => (
                <li {...props}>
                    <div>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 6,
                                fontSize: 13,
                                fontWeight: 600,
                            }}
                        >
                            {option.lockNumber}
                            <span
                                style={{
                                    display: "inline-block",
                                    padding: "1px 7px",
                                    borderRadius: 10,
                                    fontSize: 9.5,
                                    fontWeight: 700,
                                    letterSpacing: "0.3px",
                                    background: "linear-gradient(135deg, #EDE4FF, #DDD6FE)",
                                    color: "#6D28D9",
                                }}
                            >
                                {option?.elockType?.lockType?.replace(/_/g, " ")}
                            </span>
                        </div>
                        <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 2 }}>
                            {option.serialNumber} · {option.status} · 🔋 {option.batteryStatus}%
                            {option.lat && option.lang
                                ? ` · 📍 ${option.lat.toFixed(4)}, ${option.lang.toFixed(4)}`
                                : " · No GPS"}
                        </div>
                    </div>
                </li>
            )}
            renderInput={(params) => (
                <TextField
                    {...params}
                    variant="outlined"
                    placeholder="Select lock"
                    size="small"
                />
            )}
            noOptionsText="No locks found"
            loadingText="Loading locks..."
            isOptionEqualToValue={(option, value) => option?.id === value?.id}
        />
    );
};

export default LockFilter;